import * as React from "react";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useApiClient } from "../../../api";

export const AssignTeacherDialog = ({
  open,
  setOpen,
  schoolClass,
  teachers,
  onReload = () => {},
}) => {
  const ApiClient = useApiClient();
  const [teacher, setTeacher] = useState(null);

  const handleSubmit = async () => {
    try {
      const response = await ApiClient.schools.assignTeachersToClass({
        teachers: [teacher.id],
        schoolClass: schoolClass.id,
      });
      if (response.success) {
        setTeacher(null);
        setOpen(false);
        onReload();
      } else {
        console.log("Failed to assign teacher");
      }
    } catch (error) {
      console.error("Failed to assign teacher", error);
    }
  };

  const handleClose = () => {
    setTeacher(null);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>Add Teacher to Class</DialogTitle>
      <DialogContent>
        <Autocomplete
          disablePortal
          autoSelect
          options={teachers.filter((candidate) => candidate.user)}
          value={teacher}
          onChange={(_, newValue) => setTeacher(newValue)}
          getOptionLabel={(option) => option?.user?.fullName || ""}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          fullWidth
          slotProps={{
            clearIndicator: {
              sx: {
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  background: "transparent",
                },
                height: 5,
              },
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Teacher"
              placeholder="Choose a teacher"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"outlined"}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant={"contained"}
          disabled={!schoolClass?.id || !teacher?.id}
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};
